import {
  Box,
  Grid,
  Paper,
  Button,
  TextField,
  MenuItem,
  CircularProgress,
  Typography
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { getClientsAction } from 'src/store/actions/ClientManagerActions';
import { getReqHistoryAction } from 'src/store/actions/ReqHistoryActions';
import { getLastNDays } from 'src/utils/utils';

function FilterRequestHistory() {
  const dispatch = useDispatch();
  const profile = JSON.parse(sessionStorage.getItem('profile'));

  const clients = useSelector((state) => state.Clients.clients);
  const [formValues, setFormValues] = React.useState({
    values: { fromDate: getLastNDays(30), toDate: getLastNDays(0) }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // clients are also issuers
    dispatch(getClientsAction());
  }, []);

  const handleChange = (event) => {
    event.persist();
    setFormValues((formValues) => ({
      ...formValues,
      values: {
        ...formValues.values,
        [event.target.name]: event.target.value
      }
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    const filterObj = {
      issuerID: formValues.values.issuerID || '-',
      userID: formValues.values.userid || '-',
      fromDate: moment(formValues.values.fromDate).unix() || '-',
      toDate: moment(formValues.values.toDate).unix() || '-',
      status: formValues.values.status || '-'
    };
    const response = await dispatch(getReqHistoryAction(filterObj, profile));
    if (response) {
      setLoading(false);
    }
  };
  return (
    <Paper>
      <Grid
        container
        spacing={2}
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          paddingLeft: 10,
          paddingRight: 10
        }}
      >
        <Grid item xs={12} style={{ marginBottom: 0 }}>
          <Typography variant="h4">Request History</Typography>
        </Grid>
        {profile.super == 1 && (
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              select
              margin="normal"
              name="issuerID"
              label="Client"
              required
              variant="outlined"
              size="small"
              onChange={handleChange}
              value={formValues.values.issuerID || ''}
            >
              <MenuItem value="">Please select client</MenuItem>
              {clients.map((item, index) => (
                <MenuItem key={index} value={item.issuerID}>
                  {item.fullname}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        )}
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="User ID"
            margin="dense"
            name="userid"
            type="text"
            variant="outlined"
            size="small"
            onChange={handleChange}
            value={formValues.values.userid || ''}
          />
        </Grid>
        {profile?.super == 1 && (
          <>
            {' '}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                select
                margin="normal"
                name="status"
                label="Status"
                required
                variant="outlined"
                size="small"
                onChange={handleChange}
                value={formValues.values.status || ''}
              >
                <MenuItem value="">Please select status</MenuItem>
                <MenuItem value="1">Active</MenuItem>
                <MenuItem value="0">Inactive</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                id="date"
                label="From Date"
                type="date"
                fullWidth
                name="fromDate"
                onChange={handleChange}
                value={formValues.values.fromDate || ''}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                id="todate"
                label="To Date"
                type="date"
                name="toDate"
                fullWidth
                onChange={handleChange}
                value={formValues.values.toDate || ''}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>{' '}
          </>
        )}
        <Grid item xs={6}>
          <Button
            disabled={loading}
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            {loading && <CircularProgress size="1.5rem" />}
            Filter
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default FilterRequestHistory;
